import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserAccountAndAccessLevelModel } from 'src/app/models/user-account-and-access-level/user-account-and-access-level';
import { UserAccountAndAccessLevelCreateModel } from 'src/app/models/user-account-and-access-level/user-account-and-access-level-create';
import { UserAccountAndAccessLevelUpdateModel } from 'src/app/models/user-account-and-access-level/user-account-and-access-level-update';
import { AuthServiceService } from '../auth-service/auth-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserAccountAndAccessLevelService {

  private baseURL: string = environment.apiURL + '/v1/user-account-and-access-level';

  constructor(private httpClient: HttpClient, private authService: AuthServiceService) { }

  getAllUserAccountAndAccessLevel(): Observable<UserAccountAndAccessLevelModel[]> {
    return this.httpClient.get<UserAccountAndAccessLevelModel[]>(this.baseURL);
  }


  getUserAccountAndAccessLevelByUserAccountId(id: number): Observable<UserAccountAndAccessLevelModel> {
    return this.httpClient.get<UserAccountAndAccessLevelModel>(this.baseURL + '/user-account-id/' + id);
  }
  getAccessLevelByUserAccountId(): Observable<UserAccountAndAccessLevelModel> {
    const userAccountId = this.authService.getStoredUserAccountId();
    return this.httpClient.get<UserAccountAndAccessLevelModel>(this.baseURL + '/user-account-id/' + userAccountId);
  }
  createUserAccountAndAccessLevel(dto: UserAccountAndAccessLevelCreateModel): Observable<UserAccountAndAccessLevelModel> {
    return this.httpClient.post<UserAccountAndAccessLevelModel>(this.baseURL + '/create', dto);
  }
  updateUserAccountAndAccessLevel(dto: UserAccountAndAccessLevelUpdateModel): Observable<UserAccountAndAccessLevelModel> {
    return this.httpClient.patch<UserAccountAndAccessLevelModel>(this.baseURL + '/update', dto);
  }

}
